@if (canShow) {
  <dcp-navigation-button
    [url]="url"
    [title]="componentData?.title"
    [showArrow]="showArrow">
  </dcp-navigation-button>
}
